import Vue from 'vue'
import VueI18n from 'vue-i18n'
import md5 from 'js-md5'

Vue.use(VueI18n)

const i18n = new VueI18n({
  fallbackLocale: '',
  messages: {}
})

function $langt(value, params) {
  const hashKey = 'web_' + md5(value)
  let str = null
  if (params && Object.keys(params).length) {
    str = i18n.tc(hashKey, params)
    // if not find the key
    if (!i18n.te(hashKey)) {
      str = value
      Object.keys(params).forEach((e, i) => {
        str = str.replaceAll('{' + e + '}', params[e])
      })
    }
  } else {
    str = i18n.t(hashKey)
    // if not find the key
    if (!i18n.te(hashKey)) {
      str = value
    }
  }
  return str
}

Vue.prototype.$langt = $langt

export { $langt }
export default i18n
